import Lead from "./slides/Lead.svelte";
import { isEuropeanManufacturer, isEuropeanWeapon } from "./data";

export const colors = {
	background: "#101010",
	points: "#FD4D4D",
	pointsManufacturers: "#848484",
	pointsHighlighted: "#D3BA5F",
	lineChildrenDeaths: "#FFFFFF",
	lineWeaponsSold: "#C06FFF",
	lineSigsauer: "#D3BA5F",
	lineGlock: "#D3BA5F",
	mapRegions: "#2d2b37",
	// mapRegions: "#000000",
	mapBorders: "#101010",
	// mapBorders: 'transparent',
	arcs: "#E0976B",
};

const annotationsUSMap = [
	{ 
		name: "Las Vegas Strip massacre",
		label: "2017: /n Las Vegas /n 58 Tote",
		offset: { x: -100, y: -12 }
	}
]

const annotationsUSEuropeMap = [
	{ 
		name: "Las Vegas Strip massacre",
		label: "2017: /n Las Vegas /n 58 Tote",
		offset: { x: -100, y: -12 }
	}
]

const annotationsBeeswarm = [
	{ 
		name: "Las Vegas Strip massacre",
		label: "2017: Las Vegas, 58 Tote",
		offset: { x: 0, y: 90 },
		align: 'center'
	}
]

export const sections = [
	{
		id: "0_lead",
		slide: {
			component: Lead,
			kicker: "Der Waffenwahn und wir",
			headline: 'Europäische Waffen, amerikanische Opfer',
			teaser: 'Wie deutsche und österreichische Hersteller an dem Waffenwahn in den USA mitverdienen.',
		},
		background: {
			component: "shootings",
			charts: ["points"],
			lead: true,
			timeline: true,
			layout: "map",
			map: "us",
			radius: (props) => props.fatalities,
		},
	},
	{
		id: "1_map_us_shootings",
		slide: {
			headline: '',
			text: 'In den letzten 40 Jahren gab es in den USA <span class="red">142 Amokläufe und Massen&shy;schießereien</span>. 1106 Menschen sind dabei ums Leben gekommen.',
		},
		background: {
			component: "shootings",
			charts: ["points"],
			layout: "map",
			map: "us",
			radius: (props) => props.fatalities,
			annotations: annotationsUSMap,
			legendItems: ["fatalitiesScale"]
		},
	},
	{
		id: "2_map_us_shootings_german_austrian",
		slide: {
			headline: '',
			text: 'Was bei uns kaum jemand weiß: In  einem Drittel der Fälle führten die Todes&shy;schützen <span class="yellow">Waffen europäischer Konzerne</span>. Bei Schul&shy;massakern sogar in 45 Prozent der Fälle.',
		},
		background: {
			component: "shootings",
			charts: ["points"],
			layout: "map",
			map: "us",
			radius: (props) => props.fatalities,
			highlight: isEuropeanWeapon,
			annotations: annotationsUSEuropeMap,
			legendItems: ["fatalitiesScale", "europeanWeapon"]
		},
	},
	{
		id: "3_beeswarm",
		slide: {
			headline: '',
			text: 'Sandy Hook Elementary School 2012: 27 Todesopfer. Der Täter trug eine Pistole von Glock und eine von SIG Sauer. Orlando 2016, Las Vegas 2017: Bei den größten Massakern der jüngeren US-Geschichte schossen die Angreifer mit <span class="yellow">europäischen Gewehren</span>. Und die Massaker werden tödlicher ...',
		},
		
		background: {
			component: "shootings",
			charts: ["points"],
			layout: "beeswarm",
			map: "none",
			radius: (props) => props.fatalities,
			highlight: isEuropeanWeapon,
			annotations: annotationsBeeswarm,
			legendItems: ["fatalitiesScale", "europeanWeapon"]
		},
	},
	{
		id: "5_point_histogram",
		slide: {
			headline: '',
			text: 'Auch weil 2004 der Federal Assault Weapons Ban auslief. Der hatte die Produktion von halb&shy;automatischen Waffen für Privat&shy;leute verboten. Und die Mass Shootings werden häufiger. Allein 2022 gab es zwölf.'
		},
		background: {
			component: "shootings",
			charts: ["points"],
			layout: "histogram",
			map: "none",
			highlight: isEuropeanWeapon,
			legendItems: ["europeanWeapon", "otherWeapon"]
		},
	},
	{
		id: "6_linechart_weapons_sold",
		slide: {
			headline: '',
			text: 'Schusswaffen sind mittlerweile die häufigste Todes&shy;ursache für Kinder und Jugendliche in den USA. Vor Krebs, vor Verkehr&shy;sunfällen. Insgesamt sind im Land bis Ende April 2023 bereits 14.000 Menschen durch Schuss&shy;waffen gestorben.'
		},
		background: {
			component: "shootings",
			charts: ["points", "linechart_children"],
			layout: "histogram",
			map: "none",
			highlight: isEuropeanWeapon,
			visible: d => d.year >= 2000,
			legendItems: ["europeanWeapon", "otherWeapon"]
		},
	},
	{
		id: "7_linechart_production",
		slide: {
			headline: '',
			text: 'Für viele ist das eine Tragödie. Für andere ein lukratives Business. Allein im Corona-Jahr 2020 kauften Menschen in den USA fast dreimal so viele <span class="purple">Schusswaffen</span> wie noch zehn Jahre zuvor.'
		},
		background: {
			component: "shootings",
			charts: ["linechart_children", "linechart_weapons_sold"],
			layout: "histogram",
			map: "none",
			highlight: isEuropeanWeapon,
			visible: d => d.year >= 2000
		},
	},
	{
		id: "8_linechart_production",
		slide: {
			headline: '',
			text: 'Zwei der erfolgreichsten Waffen&shy;marken auf dem US-Privat&shy;markt stammen aus Deutschland und Österreich: <span class="yellow">SIG Sauer</span> und <span class="brown">Glock</span>. Das ist lukrativ: Nirgendwo auf der Welt werden mehr Pistolen und Gewehre verkauft.'
		},
		background: {
			component: "produced_weapons",
		},
	},
	// // TODO: from here on the slides are not finished yet and they contain only dummy data

	{
		id: "8_map_manufacturers",
		slide: {
			headline: '',
			text: 'So wie viele andere <span class="yellow">europäische Waffenkonzerne</span> haben sie dafür Produktions&shy;stätten in den USA ausgebaut. Das umgeht auch rechtliche Schranken. Inzwischen finden sich zahlreiche europäische Marken unter den <span class="grey">100 größten Handfeuerwaffen-Fabriken</span> im Land.'
		},
		background: {
			component: "manufacturers",
			layout: "map",
			map: "us",
			radius: (props) => props.total2021 || 10000,
			highlight: isEuropeanManufacturer,
			legendItems: ["manufacturerScale", "europeanManufacturer"]
			// showArcs: true
		},
	},
	{
		id: "9_map_manufacturers_germany",
		slide: {
			headline: '',
			text: 'Die USA leiden unter einer Epidemie der Waffen&shy;gewalt. Die Profiteure sitzen auch in Europa. In Deutschland. In Österreich.'
		},
		background: {
			component: "manufacturers",
			layout: "map",
			map: "europe",
			radius: (props) => props.total2021 || 10000,
			highlight: isEuropeanManufacturer,
			showArcs: true,
		},
	},
	{
		id: "10_map_manufacturers_germany_b",
		slide: {
			headline: '',
			text: 'Glock sitzt im Städtchen Ferlach in Kärnten. Die Gewinne von SIG Sauer landen bei zwei Männern im münsterländischen Emsdetten.'
		},
		background: {
			component: "manufacturers",
			layout: "map",
			map: "europe",
			radius: (props) => props.total2021 || 10000,
			highlight: isEuropeanManufacturer,
			showArcs: true,
		},
	},
];

sections.forEach((section) => {
	section.background = section.background || { component: null, componentProps: {} };
	section.slide = section.slide || { component: null, componentProps: {} };
});

export const sectionsById = sections.reduce((obj, item) => ({ ...obj, [item.id]: item }), {});
